<mat-toolbar
  class="!bg-gray-100 fixed z-10 !h-[67px] dark:!bg-black-600 border-b border-gray-100 dark:border-white/30 !px-0"
>
  <div
    class="custom-container w-full flex justify-between items-center min-h-[50px]"
  >
    <span class="text-[28px] font-bold dark:text-white">{{
      (appStateService.title$ | async) ?? "VOTA"
    }}</span>
    <button
      mat-icon-button
      class="example-icon"
      aria-label="Example icon-button with menu icon"
      (click)="toggleSidebar()"
    >
      <mat-icon class="material-symbols-outlined text-black-900 dark:text-white"
        >menu</mat-icon
      >
    </button>
  </div>
</mat-toolbar>
